.paletteChipDragging {
  opacity: 0.5;
}
